import "./BorderlessButton.scss";
import PropTypes from "prop-types";

const BorderlessButton = ({ id, label, icon, onClick, className }) => {
  return (
    <button
      className={`borderless-button ${className}`}
      onClick={onClick}
      id={id}
    >
      <div className={`button-icon ${icon} ${className} `} />
      {label}
    </button>
  );
};

BorderlessButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default BorderlessButton;
